export const PERIOD_OPTIONS = (t: $TSMigrationFixMe) => [
  {
    value: false,
    label: `${t("informes.perdidasGanancias.header.anualLabel")}`,
  },
  {
    value: true,
    label: `${t("informes.perdidasGanancias.header.mensualLabel")}`,
  },
]

export const MODES_INFORME = {
  BALANCE: "balance",
  PERDIDAS_GANANCIAS: "perdidasGanancias",
  SUMAS_SALDOS: "sumasSaldos",
} as const

export type ModesInformes = (typeof MODES_INFORME)[keyof typeof MODES_INFORME]

export interface InformesCommonProps {
  dateFilter?: (Date | null)[] | null
  searchValue?: string
  balance: {
    firstDropdownValue: boolean
    secondDropdownValue: number
  }
  perdidasGanancias: {
    firstDropdownValue: boolean
    secondDropdownValue: number
  }
  sumasSaldos: {
    firstDropdownValue: number | null
    secondDropdownValue: number
    maxResults: number
  }
  SoloCuentasConSaldo: boolean
}

export const INFORMES_DEFAULT_FILTERS: InformesCommonProps = {
  dateFilter: [new Date(`${new Date().getFullYear()}-01-01`), new Date()],
  searchValue: "",
  balance: {
    firstDropdownValue: false,
    secondDropdownValue: 5,
  },
  perdidasGanancias: {
    firstDropdownValue: false,
    secondDropdownValue: 4,
  },
  sumasSaldos: {
    firstDropdownValue: null,
    secondDropdownValue: 0,
    maxResults: 10,
  },
  SoloCuentasConSaldo: true,
}

export const formatInformesStorage = () => {
  const json = JSON.parse(sessionStorage.getItem("informesFilters") ?? "null")
  if (json === null) return INFORMES_DEFAULT_FILTERS
  return {
    ...json,
    dateFilter: !json?.dateFilter
      ? undefined
      : [
          new Date(json?.dateFilter?.[0]),
          json?.dateFilter?.[1] ? new Date(json?.dateFilter?.[1]) : null,
        ],
  }
}

export const transformMonthArray = (month: $TSMigrationFixMe) => {
  const monthArray = month ? Object.values(month) : []
  return monthArray.map((month, index) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const editedMonth = month[0]?.Total
      ? // @ts-expect-error TS(2571): Object is of type 'unknown'.
        month[0]?.Total
      : // @ts-expect-error TS(2571): Object is of type 'unknown'.
        month.split("/").join(" ")
    return {
      value: editedMonth,
      monthNumber: index + 1,
    }
  })
}

export const onTransformArrayData = (items: $TSMigrationFixMe) => {
  const tableData = items?.map((item: $TSMigrationFixMe) => {
    const editedDataColumns = Object.values(item?.dataColumns).map(
      (value, index) => {
        return {
          importe: value,
          monthNumber: index + 1,
        }
      }
    )

    return {
      ...item,
      dataColumns: editedDataColumns,
    }
  })

  return tableData
}
